import { useQuery } from "@tanstack/react-query";

export interface BootstrapIconConfig {
  key: string;
  label: string;
  enabled: boolean;
  displayOrder: number;
}

export interface BootstrapTaglineStyle {
  fontFamily: string;
  color: string;
  fontSize: number;
  isBold: boolean;
  isItalic: boolean;
}

export interface BootstrapFontSizes {
  small: number;
  medium: number;
  large: number;
  mobileSmall: number;
  mobileMedium: number;
  mobileLarge: number;
  defaultSize: "small" | "medium" | "large";
}

export interface BootstrapOnboardingToast {
  message1: string;
  message2: string;
  fontFamily: string;
  fontSize: number;
  fontWeight: string;
  textColor: string;
  backgroundColor: string;
  version: number;
}

export interface BootstrapData {
  version: string;
  branding: {
    logoUrl: string | null;
    logoSize: string;
    pageTitle: string;
  };
  layout: {
    pageBackground: { lightBg: string };
    fontSizes: BootstrapFontSizes;
  };
  header: {
    tagline: string;
    taglineStyle: BootstrapTaglineStyle;
    taglineVisible: boolean;
    searchPlaceholder: string;
    icons: BootstrapIconConfig[];
  };
  messaging: {
    communityMessaging: Record<string, unknown>;
    onboardingToast: BootstrapOnboardingToast;
    earlyAccessToastEnabled: boolean;
  };
  interaction: {
    autoScrollSpeed: number;
  };
  features: {
    userAccounts: { enabled: boolean };
    eventDisplay: {
      showEventsWithoutTime: boolean;
      showEventsWithoutDate: boolean;
    };
  };
}

export function useBootstrapData<T = BootstrapData>(select?: (data: BootstrapData) => T) {
  return useQuery<BootstrapData, Error, T>({
    queryKey: ["/api/bootstrap"],
    staleTime: 60 * 1000,
    select,
  });
}
